import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Prenavbar.css';
import { BsCart2 } from 'react-icons/bs';

const CartIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48">
    <path d="M14.35 43.95q-1.5 0-2.55-1.05-1.05-1.05-1.05-2.55 0-1.5 1.05-2.55 1.05-1.05 2.55-1.05 1.5 0 2.55 1.05 1.05 1.05 1.05 2.55 0 1.5-1.05 2.55-1.05 1.05-2.55 1.05Zm20 0q-1.5 0-2.55-1.05-1.05-1.05-1.05-2.55 0-1.5 1.05-2.55 1.05-1.05 2.55-1.05 1.5 0 2.55 1.05 1.05 1.05 1.05 2.55 0 1.5-1.05 2.55-1.05 1.05-2.55 1.05Zm-22.6-33 5.5 11.4h14.4l6.25-11.4Zm-1.5-3H39.7q1.15 0 1.75 1.05.6 1.05 0 2.1L34.7 23.25q-.55.95-1.425 1.525t-1.925.575H16.2l-2.8 5.2h24.55v3h-24.1q-2.1 0-3.025-1.4-.925-1.4.025-3.15l3.2-5.9L6.45 7h-3.9V4H8.4Zm7 14.4h14.4Z" />
  </svg>
);

const PreNavbar = () => {
  return (
    <div className="preNav">
      <div>
        <Link to="https://www.mi.com/in/">MI INDIA</Link> <span>|</span>
        <Link to="https://in.event.mi.com/in/install-mi-store">
          GET MI STORE APP
        </Link>{' '}
        <span>|</span>
        <Link to="https://www.mi.com/in/service/help/#category_id=1&pagenum=1&channel=1">
          ONLINE HELP
        </Link>{' '}
        <span>|</span>
        <Link to="https://www.mi.com/in/service/authorized_stores/">
          RETAIL STORE ﹀
        </Link>
      </div>

      <div>
        <Link to="https://store.mi.com/in/site/login">SIGN IN</Link>{' '}
        <span>|</span>
        <Link to="https://account.xiaomi.com/pass/register?callback=https%3A%2F%2Fstore.mi.com%2Fin%2Flogin%2Fcallback%3Ffollowup%3Dhttps%253A%252F%252Fwww.mi.com%252Fin%26sign%3DNGQyZTY1M2VjNGNjYTc5NzFlZDc1YmY2ZmM2NDFiYWMwNTU5YzUyNQ%2C%2C&sid=i18n_in_pc_pro&_locale=en_IN">
          SIGN UP
        </Link>{' '}
        <span>|</span>
        <Link to="https://store.mi.com/in/site/login">
          <BsCart2 className="cartsvg" />
        </Link>
      </div>
    </div>
  );
};

export default PreNavbar;
